/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoContattoUpdateDTO
 */
export interface AssistitoContattoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoUpdateDTO
     */
    cognome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoUpdateDTO
     */
    tipoContattoId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoUpdateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoUpdateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoUpdateDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoContattoUpdateDTO interface.
 */
export function instanceOfAssistitoContattoUpdateDTO(value: object): value is AssistitoContattoUpdateDTO {
    return true;
}

export function AssistitoContattoUpdateDTOFromJSON(json: any): AssistitoContattoUpdateDTO {
    return AssistitoContattoUpdateDTOFromJSONTyped(json, false);
}

export function AssistitoContattoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoContattoUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'tipoContattoId': json['tipoContattoId'] == null ? undefined : json['tipoContattoId'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoContattoUpdateDTOToJSON(value?: AssistitoContattoUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cognome': value['cognome'],
        'nome': value['nome'],
        'tipoContattoId': value['tipoContattoId'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
    };
}

